import clsx from 'clsx'
import type { ConfigStatus } from '../model/coverage'
import { STATUS_BADGE, STATUS_LABEL } from '../labels'

interface Props {
  status: ConfigStatus
  className?: string
}

/** Metronic light badge for a configuration status. */
export const StatusBadge = ({ status, className }: Props) => (
  <span className={clsx('badge', `badge-light-${STATUS_BADGE[status]}`, className)}>
    {STATUS_LABEL[status]}
  </span>
)
